import React from "react";

const OauthFailed = ({ redirectUrl = "https://app.noki.ai/" }) => {
  const styles = {
    body: {
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
      padding: "50px",
      backgroundColor: "#f5f5f5",
      minHeight: "100vh",
      margin: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    container: {
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "30px",
      maxWidth: "600px",
      margin: "0 auto",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    heading: {
      color: "#f44336",
      marginBottom: "20px",
    },
    paragraph: {
      margin: "10px 0",
      lineHeight: "1.5",
    },
    errorButton: {
      display: "inline-block",
      backgroundColor: "#f44336",
      color: "white",
      padding: "10px 20px",
      textDecoration: "none",
      borderRadius: "5px",
      marginTop: "15px",
      transition: "background-color 0.3s ease",
      cursor: "pointer",
      border: "none",
      fontSize: "16px",
      marginRight: "10px",
    },
    errorButtonHover: {
      backgroundColor: "#d32f2f",
    },
    redirectInfo: {
      margin: "20px 0",
      color: "#555",
    },
    button: {
      backgroundColor: "#201f48",
      color: "white",
      border: "none",
      padding: "10px 20px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px",
      margin: "20px 0",
      cursor: "pointer",
      borderRadius: "5px",
      transition: "background-color 0.3s",
    },
  };

  const [isHovered, setIsHovered] = React.useState(false);
  const redirectNow = () => {
    window.location.href = redirectUrl;
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Authentication Failed</h1>
        <p style={styles.paragraph}>
          We couldn't complete your authentication with Noki.
        </p>
        <p style={styles.paragraph}>Please try again later.</p>
        <p style={styles.paragraph}>
          Please reach out to Noki support team at support@noki.ai.
        </p>
        <a
          href="https://www.noki.ai/help"
          style={{
            ...styles.errorButton,
            ...(isHovered ? styles.errorButtonHover : {}),
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Get Help
        </a>
        <button
          style={styles.button}
          onClick={redirectNow}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#201f48")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#201f30")
          }
        >
          Go to Noki
        </button>
      </div>
    </div>
  );
};

export default OauthFailed;
